import React from 'react';
import { List } from 'semantic-ui-react'

import TitDer from '../../components/funcionales/titder';

const DetalleNivel1 = ({elemento, handleClickidLista}) => {
  return(
    <tr className=''  onClick={(ev)=>handleClickidLista(ev, elemento)}>
      <td className=''>{elemento.codigoSegmento}</td>
      <td className=''>{elemento.descrSegmento}</td>
    </tr>
  )
};

const Lista = ({list, handleClickidLista}) => {
  const nivel1Detalle = list.map((elemento, _id) => <DetalleNivel1 elemento={elemento} 
    handleClickidLista={handleClickidLista} key={elemento._id}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};

const HomeSeg2 = ({autorizacUA, styles, handleClick, list, handleClickidLista}) => {
  const a014501 = autorizacUA.findIndex( autorizac => autorizac === "014501" );

  return (
    <div>
      <List selection>
        <TitDer list={list} textBoton1="Segmentos" btnNuevo={a014501!==-1?"SI":"NO"} styles={styles} handleClick={handleClick} />
        <div>
          <table className='ui blue inverted celled selectable table' style={styles.styTableSup}>
            <thead className=''>
              <tr className=''>
                <th className='' style={{width: '30%'}}>Código</th>
                <th className='' style={{width: '70%'}}>Descripción</th>
              </tr>
            </thead>
            <Lista list={list} handleClickidLista={handleClickidLista}/>
          </table>
          <p></p>
        </div>

        {/* <Lista list={list} styles={styles} handleClickidLista={handleClickidLista}/> */}
      </List> 
    </div>
  )
};

export default HomeSeg2
